export const openSearchConfigSnippet =
`# Enables/disables the OpenSearch functionality for transaction logging. If omitted the default value is false.
nca.ds:
   aws.opensearch.transaction.logging.enabled: true
# Following properties must be set in order to establish the connection with OpenSearch:
nca.ds:
   aws.opensearch.transaction.logging.host: host
    `

export const openSearchIndexNameSnippet =
   'nca.ds.aws.opensearch.transaction.logging.index-name: "ds_transaction_log"'

export const openSearchConnectionConfigurationSnippet =
  `
  nca.ds.aws.opensearch.transaction.logging:
    # OpenSearch client socket timeout with default value 30s.
    socket-timeout: 30s
    # OpenSearch client connection timeout with default value 2s.
    connection-timeout: 2s
    # OpenSearch client connection TTL with default value 0s.
    connection-time-to-live: 0s
    # OpenSearch client maximum connections with default value 50.
    max-connections: 50`

export const openSearchIndexCreationSnippet =
`
PUT /ds_transaction_log
{
  "mappings": {
    "properties": {
      "acquirerBIN": {
        "type": "keyword"
      },
      "acsOperatorID": {
        "type": "keyword"
      },
      "acsTransID": {
        "type": "keyword"
      },
      "priorAcsTransID": {
        "type": "keyword"
      },
      "amount": {
        "type": "keyword"
      },
      "currency": {
        "type": "keyword"
      },
      "deviceChannel": {
        "type": "keyword"
      },
      "dsTransID": {
        "type": "keyword"
      },
      "priorDsTransID": {
        "type": "keyword"
      },
      "finalTransStatus": {
        "type": "keyword"
      },
      "maskedPAN": {
        "type": "keyword"
      },
      "merchantCategoryCode": {
        "type": "keyword"
      },
      "merchantCountry": {
        "type": "keyword"
      },
      "merchantID": {
        "type": "keyword"
      },
      "merchantName": {
        "type": "keyword"
      },
      "messageCategory": {
        "type": "keyword"
      },
      "protocolMessages": {
        "properties": {
          "content": {
            "type": "text"
          },
          "timestamp": {
            "type": "date",
            "format": "date_hour_minute_second_millis"
          },
          "type": {
            "type": "keyword"
          }
        }
      },
      "protocolVersion": {
        "type": "keyword"
      },
      "sdkTransID": {
        "type": "keyword"
      },
      "threeDSServerOperatorID": {
        "type": "keyword"
      },
      "threeDSServerTransID": {
        "type": "keyword"
      },
      "timestamp": {
        "type": "date",
        "format": "date_hour_minute_second_millis"
      },
      "transFlowType": {
        "type": "keyword"
      },
      "transStatusReason": {
        "type": "keyword"
      }
    }
  }
}
`